import { Reveal } from "./Reveal";

export const Ornament = ({ className = "w-40" }) => (
    <svg viewBox="0 0 160 12" className={className} fill="none" aria-hidden="true">
        <line x1="0" y1="6" x2="64" y2="6" stroke="#c9a24b" strokeWidth="0.75" />
        <line x1="96" y1="6" x2="160" y2="6" stroke="#c9a24b" strokeWidth="0.75" />
        <path d="M80 1 L85 6 L80 11 L75 6 Z" stroke="#c9a24b" strokeWidth="0.75" />
        <circle cx="69" cy="6" r="1.5" fill="#c9a24b" />
        <circle cx="91" cy="6" r="1.5" fill="#c9a24b" />
    </svg>
);

export const Chapter = ({ number, label }) => (
    <Reveal className="flex items-center gap-5" y={20}>
        <span className="font-caps text-sm tracking-[0.35em] text-[#c9a24b]" data-testid={`chapter-number-${number}`}>
            {number}
        </span>
        <span className="h-px w-14 bg-[#c9a24b]/40" />
        <span className="font-caps text-xs sm:text-sm tracking-[0.35em] uppercase text-[#efe6d6]/70">
            {label}
        </span>
    </Reveal>
);
